import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'
import { GET_DISPLAY_MAINTENANCE_BANNER, HIDE_DISPLAY_MAINTENANCE_BANNER } from '../actionTypes/Notifications/notification'

function displayBannerSuccess (bannerResult) {
  return {
    type: GET_DISPLAY_MAINTENANCE_BANNER,
    payload: bannerResult
  }
}

function hideDisplayBannerSuccess (bannerResult) {
  return {
    type: HIDE_DISPLAY_MAINTENANCE_BANNER,
    payload: false
  }
}

export const displayMaintenanceBanner = (data) => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.displayMaintenanceBanner
  return (dispatch, getState) => {
    const api = new Api()
    api.postData(url, data, result => {
      if (result && result.status) {
        if (result.DisplayMaintenanceBanner === 'true') {
          dispatch(displayBannerSuccess(result))
        }
      }
    })
  }
}

export const hideDisplayMaintenanceBanner = (data) => {
  return (dispatch, getState) => {
    dispatch(hideDisplayBannerSuccess())
  }
}



// WEBPACK FOOTER //
// ./src/actions/notifications.js